<template>
	<div class="LogB" id="register">

		<!--主体-开始-->
		<article class="IndCon">
			<section class="LogLogo flexC fl-cen">
				<h3 class="LogTit">
					<!-- <img src="@/assets/wap/images/icon/logo.png"> -->
					{{$t('message.register')}}
				</h3>
			</section>
			<!--注册-开始-->
			<ul class="LogN">
				<van-form @submit="onSubmit">
					<!-- <li class="boxradius LogD flexC"> -->
					<!-- <div class="LogH flexC Huans"><i class="LogV"><img src="@/assets/wap/images/icon/LogI01.png"></i>
							<p>{{$t('message.account')}}</p>
						</div> -->
					<!-- <van-field :label="$t('message.username1')" name="username" v-model="username" placeholder=""
							:border="false" autocomplete="off" class="LogI name"
							:rules="[{ required: true, message: $t('message.usernametips') }]" />
						<div class="iconfontll icon-gerenzhongxin1"></div>
					</li> -->

					<li class="boxradius LogD flexC">
						<!-- 	<div class="LogH flexC Huans"><i class="LogV"><img src="@/assets/wap/images/icon/LogI03.png"></i>
							<p>{{$t('message.phone')}}</p>
						</div> -->
						<van-popover v-model="qmlistshow" trigger="click" :actions="qmactions"
							:close-on-click-outside="false" :overlay="true" @select="onSelect2">
							<template #reference>
								<div class="PhoneInput_dropdown">
									<div class="PhoneInput flexC fl-bet Huans">
										<div class="PhoneInput_icon__2rYuk">{{gjqh}}</div>
										<img src="@/assets/wap/images/icon/Bro-sel.png"
											:class="{ 'icon_down_rolate': qmlistshow }">
									</div>
								</div>
							</template>
						</van-popover>
						<div class="TcLogFS_inp flexC fl-bet">
							<van-field type="tel" name="mobile" v-model="mobile" placeholder="" :border="false"
								autocomplete="off" class="LogI yzm"
								:rules="[{ required: true, message: $t('message.pleasemobile') }]" />
						</div>
						<div class="iconfontll icon-shouji"></div>
					</li>
					<li class="boxradius LogD flexC">
						<!-- <div class="LogH flexC Huans">
							<i class="LogV"><img src="@/assets/wap/images/icon/LogI01.png"></i>
							<p>{{$t('message.currency')}}</p>
						</div> -->
						<div class="regFI flexC fl-bet" @click="yyshowClick">
							<div class="regFV flexC fl-cen"><img :src="Curlang.img" style="margin-right: 5px;">
								<van-field name="lang" v-model="Curlang.label" :placeholder="$t('message.currencytips')"
									readonly="" class="LogI name" />
							</div>


							<img src="@/assets/wap/images/icon/Bro-sel.png" :class="{ 'icon_down_rolate': showPopover }">
						</div>
						<div class="select-dropdown reg-select-dropdown scrollBar_com" v-show="showPopover">
							<ul>
								<li class="Huans flexC" v-for="(item, index) in actions" :key="index"
									:class="selected==index?'active':''" @click="onSelect(index)">
									<img :src="item.img">
									<span>{{ item.label }} ({{ item.value }})</span>
								</li>
							</ul>
						</div>
					</li>
					<li class="boxradius LogD flexC">
						<!-- <div class="LogH flexC Huans"><i class="LogV"><img src="@/assets/wap/images/icon/LogI02.png"></i>
							<p>{{$t('message.password')}}</p>
						</div> -->
						<van-field name="password" :type="pass_type" v-model="password" :label="$t('message.password')"
							placeholder="" :border="false" autocomplete="off" class="LogI password"
							:rules="[{ required: true, message: $t('message.pleasepass') }]" />
						<!-- <div class="LogeyeI" :class="{ 'Loghide': pass_type=='password' }" @click="eyeBtn()"></div> -->
						<div class="iconfontll icon-jiesuo"></div>
					</li>
					<li class="boxradius LogD flexC">
						<!-- <div class="LogH flexC Huans"><i class="LogV"><img src="@/assets/wap/images/icon/LogI02.png"></i>
							<p>{{$t('message.confirmpass')}}</p>
						</div> -->
						<van-field name="password2" :type="pass_type2" v-model="password2"
							:label="$t('message.confirmpass')" placeholder="" :border="false" autocomplete="off"
							class="LogI password" :rules="[{ required: true, message: $t('message.againpass') }]" />
						<!-- <div class="LogeyeI" :class="{ 'Loghide': pass_type2=='password' }" @click="eyeBtn2()"></div> -->
						<div class="iconfontll icon-jiesuo"></div>
					</li>
					<li class="boxradius LogD flexC" v-show="register != 'SMS'">
						<!-- <div class="LogH flexC Huans"><i class="LogV"><img src="@/assets/wap/images/icon/LogI03.png"></i>
							<p>{{$t('message.yzm')}}</p>
						</div> -->
						<van-field type="number" name="yzm" v-model="yzm" :label="$t('message.yzm')" placeholder=""
							:border="false" autocomplete="off" class="LogI yzm"
							:rules="[{ required: true, message: $t('message.pleasetwcode') }]" />
						<div class="LogDNa" @click="refreshCode"><img :src="imgcode"></div>

					</li>

					<li class="boxradius LogD flexC" v-show="register == 'SMS'">
						<!-- <div class="LogH flexC Huans">
							<i class="LogV"><img src="@/assets/wap/images/icon/LogI03.png"></i>
							<p>{{$t('message.yzm')}}</p>
						</div> -->
						<van-field type="number" name="yzm" v-model="yzm" :label="$t('message.yzm')" placeholder=""
							:border="false" autocomplete="off" class="LogI yzm"
							:rules="[{ required: true, message: $t('message.pleaseyzm') }]" />
						<div class="LogFor_box LogDNa">
							<!-- <input type="button" class="LogFoz" :value="$t('message.sendcode')"
								style="line-height: 0.24rem;" @click="clickButton()" v-show="!djs"> -->
							<van-button :disabled="codeStatus" native-type="button" @click="clickButton()" v-show="!djs"
								class="LogFoz" style="line-height: 0.24rem;">
								{{$t('message.sendcode')}}
							</van-button>
							<div class="LogFoz" v-show="djs">
								<van-count-down ref="countDown" :time="60000" :auto-start="false" format="ss"
									@finish="finish" />
							</div>

						</div>
						<div class="iconfontll icon-yanzhengma"></div>
					</li>
					<li class="boxradius LogD flexC">
						<!-- <div class="LogH flexC Huans"><i class="LogV"><img src="@/assets/wap/images/icon/LogI02.png"></i>
							<p>{{$t('message.password')}}</p>
						</div> -->
						<!-- :type="pass_type" -->
						<van-field name="paypass" type="number" v-model="paypass" :label="$t('message.paypass')"
							placeholder="" :border="false" autocomplete="off" class="LogI password"
							:rules="[{ required: true, message: $t('message.firstpaypass') }]" />
						<!-- <div class="LogeyeI" :class="{ 'Loghide': pass_type=='password' }" @click="eyeBtn()"></div> -->
						<div class="iconfontll icon-jiesuo"></div>
					</li>
					<li class="boxradius LogD flexC">
						<!-- <div class="LogH flexC Huans"><i class="LogV"><img src="@/assets/wap/images/icon/LogI02.png"></i>
							<p>{{$t('message.password')}}</p>
						</div> -->
						<van-field name="inviteId" type="number" v-model="inviteId" :label="$t('message.inviteId')"
							placeholder="" :border="false" autocomplete="off" class="LogI password" />
						<div class="iconfontll icon-yanzhengma"></div>
					</li>
					<!-- <li class="LogFor flexC fl-bet">
						<label class="Logla flexC">
							<van-checkbox name="checkbox" v-model="checked"></van-checkbox>
							{{$t('message.days21')}}</p>
							<a @click="gorules" href="javascript:;">【{{$t('message.rules')}}】</a>
						</label>
					</li> -->
					<li class="Logbt">
						<van-button :disabled="submitStatus" :loading="submitStatus"
							:loading-text="$t('message.register')" round block type="info" native-type="submit"
							class="LogBut">
							{{$t('message.register')}}
						</van-button>
					</li>
				</van-form>
				<li class="Logdc flexC fl-cen">
					<p>{{$t('message.hadaccount')}}？</p>
					<router-link :to="{name: 'login'}" class="LogC">{{$t('message.login1')}}</router-link>
					<!-- <router-link to="/index" class="LogFH">{{$t('message.returnhome')}}</router-link> -->
				</li>
				<li class="Logdc flexC fl-cen">
					<router-link v-if="isHideVideo" to="/games"
						class="Logfhbtn">{{$t('message.returnhome')}}</router-link>
					<router-link v-else to="/index" class="Logfhbtn">{{$t('message.returnhome')}}</router-link>
				</li>
			</ul>
			<!--注册-结束-->
			<!-- <section class="LogFt" v-show="hidshow||!isAndroid">
				<div class="LogFtD flexC fl-cen">
					<a href="javascript:;" class="LogFtI"><img src="@/assets/wap/images/icon/LogFt01.png"></a>
					<a href="javascript:;" class="LogFtI"><img src="@/assets/wap/images/icon/LogFt02.png"></a>
				</div>
				<div class="LogFtH">{{$t('message.bottomtips')}}</div>
			</section> -->
		</article>
		<!--主体-结束-->
	</div>
</template>

<script>
	import {
		postRegister,
		sendSms,
		getAreaCodes,
		getLangs
	} from "@/api/urls";
	export default {
		name: 'register',
		data() {
			return {
				isHideVideo: false, //是否隐藏视频
				username: '',
				password: '',
				password2: '',
				mobile: '',
				code: '',
				yzm: '',
				pass_type: 'password',
				pass_type2: 'password',
				showPopover: false, //是否显示语言框
				selected: 0,
				actions: [],
				flag: false,
				Curlang: {
					label: '',
					img: "",
					value: '',
				},
				checked: true,
				imgcode: '', //图形验证码
				currencys: [], //货币列表
				register: 'SMS',
				djs: false, //倒计时
				yinsi: '',
				qmlistshow: false, //是否显示区码列表
				qmactions: [],
				countrys: [{
					nameEn: "USA",
					nameCn: "美国",
					code: "+1"
				}], //国家数组
				cindex: 5, //选中的第几个
				gjqh: '+86', //选中的国家区号
				docmHeight: '0', //初始状态可视区高度
				showHeight: '0', //实时可视区高度
				hidshow: true, //是否显示底部
				isAndroid: false, //是否为安卓系统
				paypass: '',
				inviteId: '',
				codeStatus: false, //按钮状态
				submitStatus: false, //按钮状态
			}
		},
		created() {
			this.isHideVideo = this.$store.state.isHideVideo;
			this.getAreaCodes(); //国家手机号
			//获取语言列表
			this.getLanguages();
			//仅针对安卓做处理，不然的话ios会出现新的问题
			var u = navigator.userAgent;
			var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
			if (isAndroid) {
				this.isAndroid = true;
			} else {
				this.isAndroid = false;
			}
			console.log(this.isAndroid)
			this.docmHeight = document.documentElement.clientHeight;
			// 获取URL地址
			let url = window.location.href;
			// 获取参数部分
			let params = url.split('?')[1];
			// 将参数部分转换为对象
			let paramsObj = {};
			if (params) {
				let paramsArr = params.split('&');
				for (let i = 0; i < paramsArr.length; i++) {
					let param = paramsArr[i].split('=');
					paramsObj[param[0]] = param[1];
				}
			}
			// 获取指定参数的值
			let inviteId = paramsObj['invite_id'];
			console.log(inviteId, "inviteId", url)
			if (inviteId) {
				this.inviteId = inviteId; //赋值邀请码
			}
		},
		mounted() {
			// 获取当前可视区域的高度
			// let height = document.documentElement.clientHeight
			// window.onresize = () => { // 在页面大小发生变化时调用
			//   // 把获取到的高度赋值给根div
			//   document.getElementById('register').style.height = height + 'px'
			// }
			window.onresize = () => {
				return (() => {
					this.showHeight = document.body.clientHeight
					if (this.docmHeight > this.showHeight) {
						this.hidshow = false
					} else {
						this.hidshow = true
					}
				})()
			}
		},
		methods: {
			eyeBtn() {
				var type = this.pass_type;
				if (type == 'password') {
					this.pass_type = 'text';
				} else {
					this.pass_type = 'password';
				}
			},
			eyeBtn2() {
				var type = this.pass_type2;
				if (type == 'password') {
					this.pass_type2 = 'text';
				} else {
					this.pass_type2 = 'password';
				}
			},
			//图文验证码
			getImgCode() {
				var params = {
					'lang': this.$store.state.lang,
				}
				queryImgcode(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.imgcode = data.imageCode;
					}
				})
			},
			// 获取国家手机号
			getAreaCodes() {
				var params = {
					'lang': this.$store.state.lang,
				}
				getAreaCodes(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.countrys = data;
						var actions = [];
						data.map((item, index) => {
							var conts = {
								text: item['label'] + item['value']
							};
							actions.push(conts);
						})
						this.qmactions = actions;
						// this.country = actions[0];
					}
				})
			},

			refreshCode() {
				this.getImgCode();
			},
			// 选择语言国家
			yyshowClick() {
				var that = this;
				that.showPopover = !that.showPopover;
			},
			//选择国际化
			// item, index
			onSelect(index) {
				var item = this.actions[index];
				this.selected = index;
				console.log(item);
				// console.log(index);
				this.flag = !this.flag;
				if (item.value == 'CN') {
					this.$i18n.locale = 'zh';
					this.$store.commit('setIlang', 'zh')
				} else if (item.value == 'TW') {
					this.$i18n.locale = 'tw';
					this.$store.commit('setIlang', 'tw')
				} else if (item.value == 'EN') {
					this.$i18n.locale = 'en';
					this.$store.commit('setIlang', 'en')
				} else if (item.value == 'VN') {
					// 越南语跳转到越南网站
					this.$i18n.locale = 'vn';
					this.$store.commit('setIlang', 'vn')
					// this.$router.push({
					// 				path: '/web',
					// 				query: {
					// 					url: data.url
					// 				}
					// 			})
					// 			// window.location.href = data.url;
					// this.showPopover = false;
					// return false
				}else if (item.value == 'KO') {
					this.$i18n.locale = 'ko';
					this.$store.commit('setIlang', 'ko')
				}else if (item.value == 'TH') {
					this.$i18n.locale = 'th';
					this.$store.commit('setIlang', 'th')
				}else {
					this.$toast('您所在地区不支持！');
					this.showPopover = false;
					return false
				}
				this.Curlang = item;
				this.$store.commit('setLang', item.value)
				this.showPopover = false;
				// this.$router.go(0);
			},
			//开始倒计时
			clickButton() {
				this.codeStatus = true;
				if (this.mobile == '') {
					this.$toast('请先输入手机号');
					this.codeStatus = false;
					return false;
				}
				sendSms({
					'code': this.gjqh, //手机国家区号
					'phone': this.mobile
				}).then(({
					code,
					data,
					msg
				}) => {
					if (code === 200) {
						this.djs = true;
						this.$nextTick(() => {
							this.$refs.countDown.start();
						});
						this.codeStatus = false;
					} else {
						this.$toast(msg);
						this.codeStatus = false;
					}
				})

			},
			//结束倒计时
			finish() {
				this.djs = false;
				this.$refs.countDown.reset();
			},

			//选择国家手机号
			onSelect2(action, index) {
				console.log(action)
				console.log(index)
				// this.country = this.actions[index];
				this.cindex = index;
				this.gjqh = this.countrys[index].value;
			},
			gorules() {
				//关于我们，隐私政策，责任博彩，免责声明
				// id: id
				this.$router.push({
					name: 'helpInfo',
					query: {
						title: '隐私政策'
					}
				})
			},
			getSystem() {
				var params = {
					'lang': this.$store.state.lang,
				}
				querySystem(params).then(({
					code,
					data,
					msg
				}) => {
					if (code === 200) {
						data.map((item, index) => {
							if (item['ckey'] == 'REGISTER_MODEL') {
								this.register = item['cvalue'];
							}
							if (item['ckey'] == 'CONCEAL') {
								this.yinsi = item['cvalue'];
							}
						})
					} else {

					}
				})
			},
			//提交
			onSubmit(values) {
				this.submitStatus = true;
				console.log(values);
				// console.log(this.yzm);
				// if (this.checked == false) {
				// 	this.$toast('请先同意协议');
				// 	return false;
				// }
				if (values['password'] != values['password2']) {
					this.$toast('两次输入的密码不一致');
					this.submitStatus = false;
					return false;
				}
				if (values['paypass'].length != 6) {
					this.$toast('请输入6位数字的支付密码');
					this.submitStatus = false;
					return false;
				}
				var params = {
					// "username": values['username'],
					"area_code": this.gjqh,
					"phone": values['mobile'],
					"password": values['password2'],
					"code": this.yzm,
					"with_pass": values['paypass'], //支付密码
					"invite_id": values['inviteId'], //邀请码
					"lang": this.Curlang.value,
				}
				console.log(params);
				//验证码注册
				postRegister(params).then(({
					code,
					data,
					msg
				}) => {
					if (code === 200) {
						this.$toast('注册成功');
						this.$store.commit('setToken', data)
						// this.$store.commit('setUserInfo', data.user)
						this.$store.commit('setIslookpop',false)
						setTimeout(() => {
							if (this.isHideVideo) {
								this.$router.push({
									name: 'games'
								});
							} else {
								this.$router.push({
									name: 'index'
								});
							}
							this.submitStatus = false;
						}, 2000)
					} else {
						this.$toast(msg);
						this.submitStatus = false;
						return false;
					}
				})

			},
			//获取语言列表
			getLanguages() {
				var params = {
					'lang': this.$store.state.lang,
				}
				getLangs(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						// console.log(data, "data")
						this.actions = data;
						this.Curlang = data[0];
						// 获取语言
						var langval = this.$store.state.lang;
						for (var i in this.actions) {
							if (this.actions[i].value == langval) {
								this.selected = i;
								this.Curlang = this.actions[i];
								console.log(this.Curlang, "获取语言key")
							}
						}
						//默认进入的兼容处理
						if (this.Curlang.value == '') {
							this.Curlang = this.actions[0];
							this.selected = 0;
							console.log(this.Curlang, "获取默认语言key")
							this.$i18n.locale = 'zh';
							this.$store.commit('setIlang', 'zh')
							this.$store.commit('setLang', 'CN')
							this.getVideocategory()
						}
					}
				})
			},
		},
	}
</script>

<style lang="less" scoped>
	.van-cell {
		background-color: rgba(0, 0, 0, 0);
		padding: 10px 0px;
	}

	.IndCon {
		padding-bottom: 40px;
	}

	#register .van-field__control::placeholder {
		color: #777;
		font-size: 14px;
	}

	#register .van-field__control::-webkit-input-placeholder {
		color: #777;
		font-size: 14px;
	}

	#register .van-field__control::-moz-placeholder {
		color: #777;
		font-size: 14px;
	}

	#register .van-field__control::-ms-input-placeholder {
		color: #777;
		font-size: 14px;
	}

	#register .van-field--error .van-field__control::-webkit-input-placeholder {
		color: #ee0a24;
	}

	#register .van-field--error .van-field__control::-moz-placeholder {
		color: #777;
		font-size: 14px;
	}

	#register .van-field--error .van-field__control::-ms-input-placeholder {
		color: #777;
		font-size: 14px;
	}

	.LogLogo {
		height: 150px;
	}

	.LogH {
		margin-right: 3%;
	}

	.Huans2 {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 70%;
	}

	.van-popover {
		width: 60%;
	}

	.van-popover__action {
		width: 228px;
	}

	.Logbt .van-button--normal {
		margin: 10px 0;
	}

	#register .LogFt {
		position: fixed;
		bottom: 0;
		padding: 10px 0 5px 0;
	}

	// 修改
	.LogB {
		min-height: 100vh;
		// background-image: url("../../assets/wap/images/my/bg2.jpg");
		// background-position: center center;
		// background-repeat: no-repeat;
		// background-size: cover;
		// background-color: var(--reg-bgcolor);
		background-color: var(--bg-color);
	}

	.LogBut {
		color: #fff;
		border: none;
		background-color: #FFBC41;
	}

	.darkmode .LogBut {
		color: var(--menu-color);
		background-color: var(--anbut-bgcolor);
	}

	.boxradius {
		padding: 0.05rem 0.2rem;
		color: var(--hfont-color);
		// background-color: rgba(0, 0, 0, 0.2);
		// background-color: var(--reg-color);
		background-color: var(--search-color);
		border-radius: 100px;
		border-bottom: 0 solid #d9d4d4;

		/deep/ .van-field__label {
			color: var(--hfont-color);
		}
	}

	/deep/ .van-checkbox__label {
		color: var(--hfont-color);
	}

	/deep/ .van-cell__value--alone {
		color: var(--hfont-color);
	}

	/deep/ .van-field__control {
		color: var(--hfont-color) !important;
	}

	/deep/ .van-cell {
		height: auto;
		line-height: inherit;
	}

	.LogFor_box /deep/ .van-button--default {
		padding: 0 0;
		height: auto;
		background-color: transparent;
	}

	.LogFor_box {
		color: var(--menu-color);
		background-color: rgba(0, 0, 0, 0.2);
		// background-color: var(--regcode-color);
		padding: 0.01rem 0.06rem;
		margin-right: 0.1rem;
		border-radius: 5px;

		.LogFoz {
			color: var(--menu-color);
			font-size: 0.02rem;
		}

		.van-count-down {
			color: var(--menu-color);
			font-size: 14px;
			line-height: 0.24rem;
		}
	}

	.PhoneInput {
		color: var(--hfont-color);
		width: 0.4rem;
	}

	.Logdc p {
		color: var(--font-color);
		font-size: 0.12rem;
		line-height: 0.18rem;
	}

	.LogTit {
		color: var(--font-color);
		font-size: 0.16rem;
	}

	.LogC {
		color: var(--font-color);
		font-size: 0.12rem;
		line-height: 0.18rem;
	}

	.Logfhbtn {
		margin-top: 10px;
		padding: 2px 20px;
		color: var(--font-color);
		font-size: 0.1rem;
		border: 1px solid var(--greybtn-bgcolor);
		border-radius: 5px;
	}

	.TcLogFS {
		margin: 0 0.1rem;
		height: 0.3rem;
		border-bottom: 0 solid #d9d4d4;
	}

	.iconfontll {
		font-size: 0.16rem;
	}

	.TcLogFS {
		margin: 0 0;
	}

	// ***
	.Logla {
		color: #fff;

		/deep/ .van-checkbox {
			margin-right: 0.05rem;
		}
	}

	// 弹出层+83滑动
	/deep/ .van-popup .van-popover__content {
		overflow: auto;
		border-radius: 8px;
		overflow-y: auto;
		height: 400px;
	}
</style>


// WEBPACK FOOTER //
// src/components/wap/public/register.vue